import AutoSuggestionSelectComponent from 'src/Member/components/common/auto-suggestion-select/Select';
import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import '../myidcards.scss';
import HttpHeader from 'src/Admin/shared/httpheader';

export const IdcardCoverageFilter = (props) => {
  const cName = HttpHeader.getCNAME();
  return cName.includes('keenan') || cName.includes('tpabenefits') ? (
    <div className="idcard-filter-container filter-bar-border-top filter-bar-border-bottom mt-2 mb-md-4 mb-xs-3">
      <div className="container-offset">
        <Row className="idcard-filter-container ml-3">
          <Col md={3} xs={8} className="coverage-for">
            <div className="filter-data">
              <Row className="coverage-class">
                <Col xs={6} sm={6} className="pr-0">
                  <p>
                    <span className="">
                      <b>Product Type: </b>
                    </span>
                  </p>
                </Col>
                <Col xs={6} sm={6} className="p-0 align-items-center">
                  <AutoSuggestionSelectComponent
                    options={props.CoverageTypeProps.options}
                    components={{ IndicatorSeparator: () => null }}
                    value={props.CoverageTypeProps.selectedCoverage}
                    onChange={props.CoverageTypeChangeHandler}
                    isSearchable={false}
                    inputClassName="MyIDCard-filter height-32"
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  ) : null;
};
